import type { WalletAccount } from '@dynamic-labs-sdk/client';

import type { AptosWalletAccount } from '../AptosWalletAccount.types';

export const isAptosWalletAccount = (
  walletAccount: WalletAccount
): walletAccount is AptosWalletAccount => walletAccount.chain === 'APTOS';
